import React from "react";
import { useSelector } from "react-redux";
import { selectModal } from "store/modalsSlice";

import AddBoardModal from "layout/organisms/AddBoardModal";
import AddIdeaModal from "layout/organisms/AddIdeaModal";
import AddReleaseModal from "layout/organisms/AddReleaseModal";
import CheckoutModal from "layout/organisms/CheckoutModal";
import DeclineIdeaModal from "layout/organisms/DeclineIdeaModal";
import IdeaModal from "layout/organisms/IdeaModal";
import VotersModal from "layout/organisms/VotersModal";

const ModalsManager = () => {
  const ideaModal = useSelector(selectModal("ideaModal"));
  const addBoardModal = useSelector(selectModal("addBoardModal"));
  const addIdeaModal = useSelector(selectModal("addIdeaModal"));
  const addReleaseModal = useSelector(selectModal("addReleaseModal"));
  const checkoutModal = useSelector(selectModal("checkoutModal"));
  const declineIdeaModal = useSelector(selectModal("declineIdeaModal"));
  const votersModal = useSelector(selectModal("votersModal"));

  return (
    <>
      {ideaModal && <IdeaModal {...ideaModal.data} />}
      {addBoardModal && <AddBoardModal />}
      {addIdeaModal && <AddIdeaModal {...addIdeaModal.data} />}
      {addReleaseModal && <AddReleaseModal {...addReleaseModal.data} />}
      {checkoutModal && <CheckoutModal {...checkoutModal.data} />}
      {declineIdeaModal && <DeclineIdeaModal {...declineIdeaModal.data} />}
      {votersModal && <VotersModal {...votersModal.data} />}
    </>
  );
};

export default ModalsManager;
